import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, EnumDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { PaymentMethod } from '../PaymentMethod.js';
import { PaymentStatus } from '../PaymentStatus.js';
import { TransferSettings } from '../webshops/TransferSettings.js';
export class PaymentPatch extends AutoEncoder {
}
__decorate([
    field({ decoder: StringDecoder })
], PaymentPatch.prototype, "id", void 0);
__decorate([
    field({ decoder: new EnumDecoder(PaymentStatus), optional: true })
], PaymentPatch.prototype, "status", void 0);
__decorate([
    field({ decoder: IntegerDecoder, optional: true })
], PaymentPatch.prototype, "price", void 0);
__decorate([
    field({ decoder: new EnumDecoder(PaymentMethod), optional: true })
], PaymentPatch.prototype, "method", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true, optional: true })
], PaymentPatch.prototype, "paidAt", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, optional: true })
], PaymentPatch.prototype, "transferDescription", void 0);
__decorate([
    field({ decoder: TransferSettings, nullable: true, optional: true })
], PaymentPatch.prototype, "transferSettings", void 0);
//# sourceMappingURL=PaymentPatch.js.map